module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/male-1-3a8a3498e201112b61d86f3b8881f11c.jpg";